const React = require("react")
const PopupContentWrapper = require("./src/components/popup-content-wrapper").default

exports.wrapPageElement = ({ element, props }) => {
    return (
        <>
            <PopupContentWrapper {...props}>{element}</PopupContentWrapper>
        </>
    )
}